import { ASSET_PREFIX, colors } from 'utils/constants';
import Link from 'next/link';

const IntroducingWishListModal = ({ onClose }) => (
  <div className='container' id='dimmedBackground' onClick={(e) => e.target.id === 'dimmedBackground' && onClose && onClose()}>
    <div id='message'>
      { onClose &&
        <img id='closeButton' src={`${ASSET_PREFIX}/images/close_button.svg`} style={{ cursor: 'pointer', width: '20px' }} onClick={onClose}  alt='close button - cross'/>
      }

      <p style={{ textShadow: `2px 2px ${colors.brand.pastel}`, margin: 0, fontStyle: 'italic', fontSize: '1.3em', fontWeight: 'bold' }}>
        Introducing
      </p>

      <h3 style={{ textShadow: `2px 2px ${colors.brand.pastel}`, margin: '0.2em 0 0.8em', fontSize: '1.5em' }}>
        My <strong>Wish List</strong>
      </h3>

      <p>
        You can now save your favourite prizes to your personal {''}
        <Link href='/account/wish-list'>
          <a>Wish List</a>
        </Link>
        {''}. Collect, share, and tick them off with every win!
      </p>

      <p>
        Just tap the
        <img
          src={`${ASSET_PREFIX}/images/prizes/favourite-heart-dark.svg`}
          style={{
            display: 'inline-block',
            verticalAlign: 'middle',
            padding: '0 0.5em',
            height: '20px'
          }}
        />
        icon to save a prize to your list.
      </p>
    </div>

    <style jsx>{`
     .container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        max-width: 100%;
        height: 100%;
        background-color: rgba(55,55,55,0.8);
        z-index: 999;
      }

      #message {
        position: relative;
        background-color: white;
        color: ${colors.primaryBrandGray};
        top: 50%;
        left: 50%;
        width: 90%;
        max-width: 500px;
        max-height: 95%;
        overflow-y: auto;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 2.4em 2.5em 4em 2.5em;
        border-radius: 7px;
        box-shadow: 0 0 15px #333;
        z-index: 1000;
        text-align: left;
        font-size: 1.25em;
      }
      
      #message>* {
        text-align: left;
      }

      #closeButton {
        position: fixed;
        width: 20px;
        height: 20px;
        right: 16px;
        top: 16px;
      }
    `}</style>
  </div>
);

export default IntroducingWishListModal;
